export default "__VITE_ASSET__3959ca08__"